// 감사장 관련 타입 — apps/admin 독립 SPA용 로컬 정의.
// @fiket/shared를 import하지 않으므로 shared/schemas/thankyou.ts 계약을 여기서 미러링한다.

export interface ThankYouDesignAsset {
  originalPath: string;
  s3Url: string;
  category: 'image' | 'font';
}

export interface ThankYouDesign {
  id: string;
  name: string;
  status: 'ACTIVE' | 'INACTIVE';
  sortOrder: number;
  html: string;
  assets: ThankYouDesignAsset[];
  thumbnailUrl?: string | null;
  aspectRatio: string;
}

/** 새 디자인 생성 시 기본 스켈레톤 — 모든 placeholder 포함 */
export const DEFAULT_HTML = `<!DOCTYPE html>
<html lang="ko">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1" />
<style>
  * { margin: 0; padding: 0; box-sizing: border-box; }
  body { background: #f5f5f5; }
  .frame { position: relative; min-width: 360px; max-width: 430px; margin: 0 auto; aspect-ratio: 939/1676; background: #fffdf8; }
  .content { position: absolute; inset: 0; display: flex; flex-direction: column; align-items: center; padding: 12% 10% 8%; text-align: center; }
  .title { font-size: 42px; font-weight: normal; color: #928171; }
  .photo { width: 40%; border-radius: 16px; margin-top: 24px; }
  .body { margin-top: 24px; font-size: 16px; line-height: 2; color: #4a3f35; word-break: keep-all; }
  .sig { margin-top: auto; font-size: 16px; color: #7a6a58; }
</style>
</head>
<body>
  <div class="frame">
    <div class="content">
      <h1 class="title">Thank you</h1>
      {% if photoUrl %}<img class="photo" src="{{ photoUrl }}" alt="" />{% endif %}
      <p class="body">{{ message | nl2br }}</p>
      <p class="sig">{{ names }}</p>
    </div>
  </div>
</body>
</html>
`;
